/* eslint-disable no-undef */
const BASE_URL = {
  dev: 'https://ws-dev.ubiqeyes.com',
  uat: 'https://ws-uat.ubiqeyes.com',
  prod: 'https://ws.ubiqeyes.com',
}

const BASE_URL_FRONT = {
  dev: 'https://web-dev.ubiqeyes.com',
  uat: 'https://web-uat.ubiqeyes.com',
  prod: 'https://www.ubiqeyes.com',
}

const GRAPHQL_URLS = {
  dev: 'https://ws-dev.ubiqeyes.com/graphql',
  uat: 'https://ws-uat.ubiqeyes.com/graphql',
  prod: 'https://ws.ubiqeyes.com/graphql',
}

const USER_INTERACTION = {
  dev: true,
  uat: true,
  prod: true,
}

const REGION = {
  dev: 'eu-west-3',
  uat: 'eu-west-3',
  prod: 'eu-west-3',
}

const USER_POOL_ID = {
  dev: 'eu-west-3_CkNP7Nq7e',
  uat: 'eu-west-3_0yyL5JmwP',
  prod: 'eu-west-3_c0sS5QRIO',
}

const USER_POOL_WEB_CLIENT_ID = {
  dev: '6orhgvtmdmbnami0vvlvp2bpuo',
  uat: '29qjmjeeutfink1b7a10ud9cel',
  prod: '7fm4fvchvrm65v161h5d2sanhk',
}

const STRIPE_PUBLIC_KEY = {
  dev: 'pk_test_51KybeMFTXP6UVS2b4ViLeySx4cgtkE52Ysa2Xbv0kzO4T7j66f4H3BLwPXA2wonYwGdCbf6rTZZhcfID5N3MbikI009mRu8BeV',
  uat: 'pk_test_51L7yzNG5vf2Z1odopRa5M1YmkmEr91jMTEyP7yjr8BELNz3LsKwIigWIdcWSqB9Xn6tCdqAnrPJ0PMEqGPQUGdXp00MyYCfSTN',
  prod: 'pk_live_51L7yzNG5vf2Z1odoxN1RmFZdFJtpxXj4NuNZfsmg5CZZGS3MhZ8fY7KfNQhwUOwAhxDKlPGshHI4ibU9JeN5bTvR006Ox5VUnZ',
}

const GA_ID = {
  dev: 'G-QPYC1VF9DG',
  uat: 'G-QPYC1VF9DG',
  prod: 'G-6MHKZ0Q7Q6',
}

const GOOGLE_APP_KEY = 'AIzaSyDhrH3hl39Yu-vo3Xc3_ddnpL0sdnQANRQ'

const CONTACT_MAIL = 'serviceclient@ubiqeyes.com'

const {
  REACT_APP_INFRA = 'dev',
  REACT_APP_PREFIX = '',
  NODE_ENV = 'dev',
} = process.env
const REACT_APP_STRIPE_PB = STRIPE_PUBLIC_KEY[REACT_APP_INFRA]
const API_BASE_URL = BASE_URL[REACT_APP_INFRA]
const FRONT_BASE_URL = BASE_URL_FRONT[REACT_APP_INFRA]
const GRAPHQL_URL = GRAPHQL_URLS[REACT_APP_INFRA]
const AUTH_PERM = USER_INTERACTION[REACT_APP_INFRA]
const AWS_REGION = REGION[REACT_APP_INFRA]
const AWS_USER_POOL_ID = USER_POOL_ID[REACT_APP_INFRA]
const AWS_USER_POOL_WEB_CLIENT_ID = USER_POOL_WEB_CLIENT_ID[REACT_APP_INFRA]
const GA_MESURE_ID = GA_ID[REACT_APP_INFRA]

export default {
  API_BASE_URL,
  REACT_APP_PREFIX,
  REACT_APP_INFRA,
  GRAPHQL_URL,
  CONTACT_MAIL,
  GOOGLE_APP_KEY,
  NODE_ENV,
  fetchPolicy: 'network-only',
  notifyOnNetworkStatusChange: true,
  LIMIT: 20,
  REACT_APP_STRIPE_PB,
  FRONT_BASE_URL,
  USER_INTERACTION,
  AUTH_PERM,
  AWS_REGION,
  AWS_USER_POOL_ID,
  AWS_USER_POOL_WEB_CLIENT_ID,
  GA_MESURE_ID,
}
